import { render, staticRenderFns } from "./CalendarLegend.vue?vue&type=template&id=4e702215&"
import script from "./CalendarLegend.vue?vue&type=script&lang=js&"
export * from "./CalendarLegend.vue?vue&type=script&lang=js&"
import style0 from "./CalendarLegend.vue?vue&type=style&index=0&id=4e702215&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports